<ng-template #template>
  <div
    #modal
    class="modal-overlay flex flex-col"
    [@overlayPaneAnimation]="animationState"
    (@overlayPaneAnimation.done)="animationDone($event)"
    [style.backgroundColor]="bgColor">
    <div class="flex row w-full h-full">
      <!-- -->
       <div
        #gradient
        class="flex center bg-primary text-on-primary rounded-l-md default-style"
        [class.hidden]="!gradient.innerHTML.trim()" 
        [style.maxWidth]="infoMaxWidth"
        [style.width]="infoWidth">
        <ng-content select="[info]"></ng-content>
      </div> 
      <!-- <div class="flex flex flex-1 flex-col content-wrapper" [class.withInfo]="hasInfoContent" [class.relative]="hasInfoContent"> -->
      <div
        class="flex flex-1 flex-col content-wrapper relative"
        style="overflow: auto"
        [class.withInfo]="widthInfoShadow">
        @if (!hideHeader) {
          <div
            class="header flex shrink-0 flex-col"
            [ngStyle]="headerStyle"
            [ngClass]="{ shadowed: shadowed, 'shrink-header': shrinkHeader, 'absolute-header': absoluteHeader }">
            <div class="flex w-full justify-between items-center">
              <div class="flex">
                <div class="flex header-title items-center">
                  <!-- <div *ngIf="icon" class="icon"><i class="icon-{{ icon }}"></i></div> -->
                  @if (title || forceTitle) {
                    <div
                      class="title">
                      <span [innerHTML]="title"></span>
                      <ng-content select="[appendTitle]"></ng-content>
                    </div>
                  }
                </div>
                <ng-content select="[header]"></ng-content>
              </div>
              <div class="close-button flex">
                <ng-content select="[actions]"></ng-content>
                <button
                  class="button icon clean round"
                  style="color: currentColor"
                  [disabled]="blockClosing"
                  (click)="close()">
                  <i class="icon-cancel-1"></i>
                </button>
              </div>
            </div>
            <div class="flex w-full">
              <ng-content select="[postHeader]"></ng-content>
            </div>
          </div>
        }
        <div
          class="body flex flex-1"
          [style.padding]="noPadding ? '0px' : null"
          [style.overflow]="hideOverflow ? 'hidden' : 'auto'">
          <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
          @if (bodyText) {
            <div [innerHTML]="bodyText"></div>
          }
        </div>
        @if (showButtons) {
          <div
            class="footer flex shrink-0 justify-end"
            [ngClass]="{ ' items-center': !hideCloseButton, shadowed: shadowed }">
            @if (!hideCloseButton) {
              <button
                class="button shrink-0 clean no-shadow cancel-button"
                (click)="close()"
                [disabled]="blockClosing">
                {{ cancelButton | translate }}
              </button>
            }
            @if (submitButtonUrl) {
              <a
                [href]="submitButtonUrl"
                download
                class="button shrink-0"
                (click)="close()">
                {{ submitButton | translate }}
              </a>
            } @else {
              <div class="flex">
                <ng-content select="[submit-actions]"></ng-content>
                <!-- class="main-menu-button highlight shrink-0 modal-overlay-submit-button {{ submitButtonClasses }}" -->
                @if (!hideSubmitButton) {
                  <button
                    mat-flat-button
                    color="primary"
                    (click)="submit()"
                    [disabled]="disabled"
                    [ngStyle]="submitButtonStyle">
                    <!-- <i *ngIf="icon" class="icon-{{ icon }}"></i> -->
                    @if (submitButtonIcon) {
                      <i
                      class="icon-{{ submitButtonIcon }}"></i>
                    }
                    <span class="label">{{ submitButton | translate }}</span>
                  </button>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</ng-template>

<ng-template #contentTemplate>
  <div
    class="w-full custom-overlay"
    [class.full-screen]="fullScreen"
    [@overlayPaneAnimation]="animationState"
    (@overlayPaneAnimation.done)="animationDone($event)"
    [style.backgroundColor]="bgColor">
    <ng-content></ng-content>
  </div>
</ng-template>

<ng-template #htmlContainer>
  <div [innerHtml]="htmlContent"></div>
</ng-template>
